import Text from './Text';

import './styles/TermsText.css';

export default function TermsText() {
  return (
    <>
      <div className="terms-text__container">
        <Text className="terms-text__heading font-size-large">
                                                                                                    1. Introduction
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    1.1. Acceptance of Terms and Conditions
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    By using or accessing Suarte's platform, users agree to comply with and be bound by these Terms and Conditions.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    1.2. Changes to Terms and Conditions
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Suarte reserves the right to modify or update these Terms and Conditions at any time, and users are responsible 
                                                                                                    for regularly reviewing them.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    1.3. Eligibility and Registration
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Users must be at least 18 years old to register and use Suarte's platform. Registration requires providing 
                                                                                                    accurate and complete information.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    2. Intellectual Property Rights
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    2.1. Ownership
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Suarte owns or licenses all rights, titles, and interests in the platform's content, features, and functionality.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    2.2. License Grant
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Suarte grants users a limited, non-exclusive, non-transferable, and revocable license to access and use the 
                                                                                                    platform for personal, non-commercial purposes.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    2.3. Copyright
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Copyright gives artists who have created fixed, tangible works a bundle of rights in those works. 
                                                                                                    The rights provide both artistic protection and ensure that artists can profit from what they’ve made. 
                                                                                                    After an artist creates a piece, they have the right to make copies of their work, distribute those copies, 
                                                                                                    perform or display the work publicly, or make works that derive from the original.
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Not all of those rights transfer to the collector who goes on to purchase the piece. While many collectors assume 
                                                                                                    that a work’s copyright is transferred when they purchase a painting or a sculpture, that is not the case. 
                                                                                                    Copyright only transfers to the piece’s new owner if its artist evidences that it is his or her intent to transfer it. 
                                                                                                    What does this mean in practice? If you buy a painting from an artist, you then have the right to display your painting. 
                                                                                                    But, unless you’ve received explicit permission from the artist, you do not have the legal right to take pictures of the 
                                                                                                    piece, make BoardCards, and sell them.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    2.4. Colección "Arte hecho por I.A."
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Las obras que integran la colección "Arte hecho por I.A." son creaciones originales de titularidad de MILFSHAKES, S.L., 
                                                                                                    quien ostenta la plena propiedad y los derechos de autor y de explotación sobre las mismas.
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Cualquier referencia a "I.A." constituye una denominación artística o conceptual utilizada por MILFSHAKES, S.L. en el marco 
                                                                                                    del proyecto, sin que ello implique reconocimiento de autoría a favor de terceros ni declaración sobre el proceso técnico 
                                                                                                    de creación, toda vez que la colección constituye un proyecto artístico que explora los límites entre creatividad, tecnología 
                                                                                                    y autoría. En dicho sentido, las denominaciones empleadas forman parte del discurso creativo y no constituyen declaración 
                                                                                                    técnica sobre el proceso de producción.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    3. User Content
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    3.1. License Grant by Users
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Users grant Suarte a worldwide, perpetual, irrevocable, non-exclusive, royalty-free, and sublicensable license to use, 
                                                                                                    promote, modify, distribute, and display user content on the platform.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    3.2. Representations and Warranties
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Users represent and warrant that they have all necessary rights and permissions to submit user content to the platform.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    3.3. Removal of User Content
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Suarte reserves the right to remove or modify user content at its sole discretion, without prior notice.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    4. User Conduct
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    4.1. Prohibited Activities
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Users agree not to engage in activities that violate these Terms and Conditions or any applicable laws and 
                                                                                                    regulations, infringe upon others' rights, or interfere with the operation of the platform. 
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    5. Privacy Policy
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    5.1. Incorporation of Privacy Policy
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Suarte's Privacy Policy is incorporated into these Terms and Conditions and outlines the collection, use, and disclosure of users' personal information. 
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    6. Third-Party Links
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    6.1. External Links
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    The platform may contain links to external websites, and Suarte is not responsible for the content or practices of such websites. 
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    7. Termination
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    7.1. Right to Terminate
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Suarte reserves the right to terminate or suspend user access to the platform at any time, without notice, for any reason.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    8. Galleries and Artists
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    8.1. Gallery Responsibilities
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Galleries are responsible for managing artist profiles, uploading artworks, and establishing commercial agreements with artists.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    8.2. Artist Profiles
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Artists can claim their profiles and access platform features, monitor performance, connect with audiences, and increase their visibility.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    8.3. Commercial Agreements
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Galleries and artists must establish clear and fair financial agreements to ensure mutual benefits.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    9. Limited Editions
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Suarte offers exclusive, high-quality limited edition prints produced and distributed with the permission of the artwork's legal representative.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    10. Artwork Contract
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    10.1. Artwork Representation
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    By uploading or providing information about an artwork, galleries and artists represent that they have the necessary rights, permissions, 
                                                                                                    and authority to offer the artwork for sale on Suarte's platform. They also warrant that the information and images provided 
                                                                                                    are accurate, complete, and not misleading.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    10.2. Artwork Authenticity
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Artwork representatives are responsible for ensuring the authenticity and quality of the artworks offered on the platform. Suarte is not liable 
                                                                                                    for any disputes or claims arising from the sale or display of counterfeit, forged, or misrepresented artworks.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    10.3. Copyright
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Sellers acknowledge that they are responsible for obtaining and maintaining any necessary copyright, trademark, or other intellectual property 
                                                                                                    rights associated with the artworks they offer for sale on Suarte's platform.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    10.4. Artwork Pricing and Sales
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Sellers are responsible for setting the price of their artworks, excluding limited editions, and for completing sales transactions in accordance with 
                                                                                                    these Terms and Conditions and any applicable laws and regulations.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    10.5. Shipping and Handling
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Sellers are responsible for properly packaging and shipping sold artworks to buyers in a timely manner, as well as providing tracking information and 
                                                                                                    maintaining communication with buyers throughout the shipping process.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    10.6. Returns and Refunds
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Sellers must adhere to Suarte's return and refund policy, which requires them to accept returns and issue refunds for artworks in accordance with 
                                                                                                    the platform's guidelines and any applicable laws.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    11. Invoices and Billing
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    11.1. Billing System
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Suarte uses an electronic billing system to simplify invoicing and payments for galleries.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    11.2. Electronic Billing
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Invoices are issued electronically and have the same legal validity as paper invoices.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    11.3. Invoice Document
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Suarte provides detailed monthly digital documents outlining sellers' financial activities on the platform.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    11.4. Paying Suarte with a Negative Balance
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    If the gallery has a negative balance, it must transfer the specified amount to Suarte within 14 days after the invoice is issued.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    11.5. Changing Billing Information
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Users can update their billing information by visiting the "bank account" section in their profile menu and saving any changes.
        </Text>

        <Text className="terms-text__subheading font-size-medium">
                                                                                                    11.6. Viewing and Managing Payment History and Invoices
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Users can access the "Invoices" section in their profile menu to view and manage their payment history and invoices.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    12. Disclaimer of Warranties and Limitation of Liability
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Suarte provides the platform on an "as is" and "as available" basis, without warranties of any kind. Suarte is not liable 
                                                                                                    for any damages arising from the use of or inability to use the platform.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    13. Indemnification
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Users agree to indemnify and hold harmless Suarte and its affiliates, officers, directors, employees, and 
                                                                                                    agents from any claims, damages, losses, or expenses arising from their use of the platform or violation of 
                                                                                                    these Terms and Conditions.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    14. Governing Law and Jurisdiction
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    Although Suarte is not responsible for any disputes arising between sellers and purchasers, it reserves the right to intervene and make 
                                                                                                    a final decision in the event a resolution cannot be reached by the involved parties. This decision may be made at Suarte's discretion when 
                                                                                                    it deems necessary or when requested by either party. If the Seller or the Purchaser for any reason decides to bring a claim against Suarte, 
                                                                                                    these Terms and Conditions are governed by the laws of Spain, and users agree to submit to the exclusive jurisdiction of the courts of Spain 
                                                                                                    for any disputes arising out of or relating to the use of the platform.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    15. Severability
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    If any provision of these Terms and Conditions is deemed invalid or unenforceable, the remaining provisions will continue in full force and effect.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    16. Entire Agreement
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    These Terms and Conditions, along with any other agreements and policies incorporated by reference, constitute the entire agreement between users and 
                                                                                                    Suarte concerning the use of the platform and supersede any prior agreements.
        </Text>

        <Text className="terms-text__heading font-size-large">
                                                                                                    17. Contact Information
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    If users have any questions or concerns regarding these Terms and Conditions or the platform, they can contact Suarte at the provided 
                                                                                                    contact information on the platform.
        </Text>

        <Text className="terms-text__text font-size-medium" paragraph justify>
                                                                                                    By incorporating all the necessary information and covering crucial points, these Terms and Conditions aim to protect the interests of Suarte,
                                                                                                    galleries, artists, and users while ensuring a secure and enjoyable experience for all parties involved.
        </Text>
      </div>
    </>
  );
}
